<template>
<button
  v-if="$can('events.view.presenter')"
  @click="download()"
  class="btn btn-fill btn-wd btn-pptx btn-block btn-router"
>
  PPT Clientes Reservas
</button>
</template>

<script>
import {mapGetters} from 'vuex'
import PptPresenter from 'src/services/PptPresenter'
import swal from 'sweetalert2'

export default {
  name: 'BtnDownloadPptxSubstituteCustomers',
  computed: {
    ...mapGetters('tickets', {
      elegibleNotWinner: 'elegibleNotWinner'
    }),
    ...mapGetters('customers', {
      customers: 'modelById'
    }),
    ...mapGetters('project', {urlImages: 'urlImages'})
  },
  methods: {
    async download () {
      swal({
        title: 'Confirmação',
        html: 'Confirmar download da apresentação.',
        type: 'info',
        confirmButtonText: 'Iniciar',
        showCloseButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const customersElelibleNotWinner = this.elegibleNotWinner.slice(0, 20)
          await PptPresenter.make(customersElelibleNotWinner, this.customers, 'Reservas', this.urlImages)
          return 'ok'
        }
      })
    }
  }
}
</script>

<style scoped>
  /* .btn-pptx {
    background-color: #D04526;
    border-color: #D04526;
  } */
</style>



// WEBPACK FOOTER //
// src/pages/Events/Actions/BtnDownloadPptxSubstituteCustomers.vue